import React, {useContext, useEffect } from "react";
import { Button, Card } from "react-bootstrap";
import {
  FaArrowLeft,
  FaComments,
  FaMapMarkerAlt,
  FaMoneyBillWave,
  FaPhone,
  FaStar,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "../../../assets/css/Customer/CustomerDashboard/CustomerAcceptRide.css";
import "../../../assets/css/Customer/general/BottomNav.css";
import BottomNav from "../../../components/Customer/general/BottomNav";
import AppContext from "../../../context/AppContext";
import axios from "axios";

const CustomerAcceptRide = () => {
  const {
    selectedRideforFindingDriver,
    setSelectedRideforFindingDriver,
    baseUrl,
    authToken,
  } = useContext(AppContext);
  const navigate = useNavigate();

  const handleCall = () => {
    window.open(`tel:${selectedRideforFindingDriver?.tddriver?.driverphone}`);
  };

  const fetchAcceptedRide = () => {
    const formData = new FormData();
    formData.append("status", selectedRideforFindingDriver?.status);

    axios
      .post(`${baseUrl}/customer/ride/viewRides`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((response) => {
        if (response.data.success === true) {
          const updatedRide = response.data.rides.find(
            (r) => r.id === selectedRideforFindingDriver?.id,
          );

          // ✅ Pehle check karo ke ride mili ya nahi
          if (!updatedRide) return;

          // ✅ Ride update karo context mein
          setSelectedRideforFindingDriver(updatedRide);

          // ✅ Completed hone pe rating screen pe bhejo
          if (updatedRide.status === "completed") {
            navigate("/customer-rating", {
              state: {
                tdride_id: updatedRide.id,
                tddriver_id: updatedRide.tddriver?.id,
              },
            });
          }
        }
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    fetchAcceptedRide();
    const interval = setInterval(() => {
      fetchAcceptedRide();
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="customer-accept-ride-container">
      <div className="customer-accept-ride-map">
        <div className="customer-accept-ride-map-overlay">
          <Button
            variant="light"
            className="customer-accept-ride-back-btn"
            onClick={() => navigate(-1)}
          >
            <FaArrowLeft />
          </Button>
          <div className="customer-accept-ride-eta-badge">
            <div className="customer-accept-ride-eta-text">
              <strong>The driver's on the way</strong>
              <p>Please don't be late</p>
            </div>
            <div className="customer-accept-ride-eta-time">6 min</div>
          </div>
        </div>
        <iframe
          title="Map"
          width="100%"
          height="100%"
          frameBorder="0"
          style={{ border: 0 }}
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d108891.85397793758!2d73.96380554335937!3d32.15682290000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39215f55ab8ae64d%3A0xc4c1cc296a2fb9e9!2sGujranwala%2C%20Punjab%2C%20Pakistan!5e0!3m2!1sen!2s!4v1234567890123!5m2!1sen!2s"
          allowFullScreen
        />
      </div>

      <div className="customer-accept-ride-details">
        <Card className="customer-accept-ride-card">
          <Card.Body>
            {/* Driver Info */}
            <div className="customer-accept-ride-driver-section">
              <div className="customer-accept-ride-driver-info">
                <img
                  src={`https://ui-avatars.com/api/?name=${selectedRideforFindingDriver?.tddriver?.drivername}&background=1B9B82&color=fff`}
                  alt="Driver"
                  className="customer-accept-ride-driver-avatar"
                />
                <div className="customer-accept-ride-driver-details">
                  <h5
                    className="customer-accept-ride-driver-name"
                    style={{ fontWeight: "bold" }}
                  >
                    {selectedRideforFindingDriver?.tddriver?.drivername}
                  </h5>
                  <div className="customer-accept-ride-driver-stats">
                    <span>
                      <FaStar color="#f1c40f" /> 4.8 (127)
                    </span>
                  </div>
                </div>
              </div>
              <div className="customer-accept-ride-action-buttons">
                <Button
                  className="customer-accept-ride-message-btn"
                  onClick={() => navigate("/customer-chat")}
                >
                  <FaComments />
                </Button>
                <Button
                  className="customer-accept-ride-call-btn"
                  onClick={handleCall}
                >
                  <FaPhone />
                </Button>
              </div>
            </div>

            {/* OTP PIN */}
            <div className="customer-accept-ride-car-section">
              <div className="customer-accept-ride-car-info">
                <h6>Start Ride PIN</h6>
                <p>Share with your driver</p>
              </div>
              <div className="pin-section-vertical">
                <div className="pin-boxes-horizontal">
                  {selectedRideforFindingDriver?.pin_to_start
                    ?.toString()
                    .split("")
                    .map((digit, index) => (
                      <span key={index} className="customer-accept-ride-badge">
                        {digit}
                      </span>
                    ))}
                </div>
                <p className="pin-footer-text">Start Ride PIN</p>
              </div>
            </div>

            {/* Route */}
            <div className="customer-accept-ride-route-section">
              <div className="customer-accept-ride-route-item">
                <FaMapMarkerAlt />
                <div className="customer-accept-ride-route-details">
                  <h6>{selectedRideforFindingDriver?.pickuplocation}</h6>
                  <p>
                    {selectedRideforFindingDriver?.bookingTime} •{" "}
                    {selectedRideforFindingDriver?.pickuplocation}
                  </p>
                </div>
              </div>
            </div>

            {/* Fare */}
            <div className="customer-accept-ride-fare-section">
              <h6 style={{ fontWeight: "bold" }}>
                Total Fare Rs.
                {
                  selectedRideforFindingDriver?.bookingBiddings?.find(
                    (b) => b.status === "accepted",
                  )?.bidAmounts
                }
              </h6>
              <div className="customer-accept-ride-payment-info">
                <FaMoneyBillWave />
                <div className="customer-accept-ride-payment-details">
                  <h6>{selectedRideforFindingDriver?.paymentmethod}</h6>
                  <p>Pay after the ride end</p>
                </div>
              </div>
            </div>
          </Card.Body>
        </Card>
      </div>
      <BottomNav />
    </div>
  );
};

export default CustomerAcceptRide;